import React from 'react'
import LinkAnimate from 'utils/hooks/linkAnimate'

function NavLink(props) {
  const { data, className = '' } = props

  const title = data.block.document ? data.block.document.data.title.text : ''
  const slug = data.block.document ? data.block.document.data.slug.text : ''
  const extLink = data.block.document ? data.block.document.data?.link.url : ''

  if (!data.block.document?.data.type) {
    return (
      <LinkAnimate className={className} to={slug}>
        {title}
      </LinkAnimate>
    )
  } else {
    return (
      <a href={extLink} className={className} target="_blank" rel="noopener noreferrer">
        {title}
      </a>
    )
  }
}

export default NavLink
